// Category Definitions - 15 Educational Categories
export const categories = [
  {
    id: 'math',
    name: 'Math',
    description: 'Numbers, operations, and problem solving',
    icon: '🔢',
    color: '#3498db',
    emoji: '➕'
  },
  {
    id: 'science',
    name: 'Science',
    description: 'Explore the natural world and discoveries',
    icon: '🔬',
    color: '#2ecc71',
    emoji: '🧪'
  },
  {
    id: 'geography',
    name: 'Geography',
    description: 'Countries, capitals, and world landmarks',
    icon: '🌍',
    color: '#1abc9c',
    emoji: '🗺️'
  },
  {
    id: 'animals',
    name: 'Animals',
    description: 'Wildlife, habitats, and animal facts',
    icon: '🦁',
    color: '#e67e22',
    emoji: '🐾'
  },
  {
    id: 'history',
    name: 'History',
    description: 'Important events and historical figures',
    icon: '📜',
    color: '#95a5a6',
    emoji: '🏛️'
  },
  {
    id: 'space',
    name: 'Space',
    description: 'Planets, stars, and the universe',
    icon: '🚀',
    color: '#34495e',
    emoji: '🪐'
  },
  {
    id: 'english',
    name: 'English',
    description: 'Grammar, vocabulary, and language',
    icon: '📝',
    color: '#e74c3c',
    emoji: '📖'
  },
  {
    id: 'shapes',
    name: 'Shapes',
    description: 'Geometry and spatial reasoning',
    icon: '🔷',
    color: '#3498db',
    emoji: '⭕'
  },
  {
    id: 'colors',
    name: 'Colors',
    description: 'Color theory and mixing',
    icon: '🌈',
    color: '#9b59b6',
    emoji: '🎨'
  },
  {
    id: 'music',
    name: 'Music',
    description: 'Instruments, notes, and musical concepts',
    icon: '🎵',
    color: '#f39c12',
    emoji: '🎹'
  },
  {
    id: 'sports',
    name: 'Sports',
    description: 'Games, rules, and athletic knowledge',
    icon: '⚽',
    color: '#2ecc71',
    emoji: '🏀'
  },
  {
    id: 'food',
    name: 'Food',
    description: 'Nutrition, cooking, and ingredients',
    icon: '🍕',
    color: '#e67e22',
    emoji: '🍔'
  },
  {
    id: 'technology',
    name: 'Technology',
    description: 'Computers, coding, and digital world',
    icon: '💻',
    color: '#3498db',
    emoji: '🖥️'
  },
  {
    id: 'art',
    name: 'Art',
    description: 'Creativity, artists, and techniques',
    icon: '🎨',
    color: '#9b59b6',
    emoji: '🖌️'
  },
  {
    id: 'nature',
    name: 'Nature',
    description: 'Environment, ecology, and conservation',
    icon: '🌿',
    color: '#2ecc71',
    emoji: '🌳'
  }
];

// Get category by ID
export const getCategoryById = (id) => {
  return categories.find(cat => cat.id === id);
};

// Get all category IDs
export const getCategoryIds = () => {
  return categories.map(cat => cat.id);
};

// Get category count
export const getCategoryCount = () => {
  return categories.length;
};
